var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0999 0.900391C1.60873 0.900391 0.399902 2.10922 0.399902 3.60039V17.4004C0.399902 18.8916 1.60873 20.1004 3.0999 20.1004H16.8999C18.3911 20.1004 19.5999 18.8916 19.5999 17.4004V3.60039C19.5999 2.10922 18.3911 0.900391 16.8999 0.900391H3.0999ZM7.9363 8.43679C8.28777 8.08532 8.28777 7.51547 7.9363 7.16399C7.58483 6.81252 7.01498 6.81252 6.66351 7.16399L3.96351 9.86399C3.61203 10.2155 3.61203 10.7853 3.96351 11.1368L6.66351 13.8368C7.01498 14.1883 7.58483 14.1883 7.9363 13.8368C8.28777 13.4853 8.28777 12.9155 7.9363 12.564L5.87269 10.5004L7.9363 8.43679ZM13.3363 7.16399C12.9848 6.81252 12.415 6.81252 12.0635 7.16399C11.712 7.51547 11.712 8.08532 12.0635 8.43679L14.1271 10.5004L12.0635 12.564C11.712 12.9155 11.712 13.4853 12.0635 13.8368C12.415 14.1883 12.9848 14.1883 13.3363 13.8368L16.0363 11.1368C16.3878 10.7853 16.3878 10.2155 16.0363 9.86399L13.3363 7.16399Z",
    fill: "#E7C009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/Logo4.5da4c6e0c53e6745b25529891ef82458.svg";
export { ForwardRef as ReactComponent };